
























import {Prop, Component, Vue} from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class AbstractRadioQuestionView extends Vue {

    @Prop()
    protected question!: any;

}
